import { ExportOutlined, PoweroffOutlined } from '@ant-design/icons';
import { Avatar, Card, Flex, Skeleton, Tooltip } from 'antd';
import { MonitoringItem, MonitoringItemStatus } from './Monitoring';
import { useMemo } from 'react';
import { formatDuration } from '@leedpulse-monorepo/utils';

interface MonitoringTileProps {
  isLoading: boolean;
  item: MonitoringItem;
}

export default function MonitoringTile({ isLoading, item }: MonitoringTileProps) {
  const isClickable = useMemo(() => {
    return !isLoading && (item.onClick || item.redirectUrl);
  }, [item]);

  return (
    <Card
      style={{ width: '100%', padding: 0 }}
      hoverable
      size="small"
      styles={{
        body: {
          padding: 16,
          height: '100%',
        },
      }}
      onClick={function () {
        if (isLoading) return;

        if (item.onClick) {
          item.onClick(item.value);
          return;
        }

        if (item.redirectUrl) {
          window.open(item.redirectUrl, '_blank');
        }
      }}
    >
      <div className="overview-page-stats__card-content">
        {isLoading ? (
          <Skeleton active paragraph />
        ) : (
          <>
            <Avatar
              style={{ backgroundColor: '#f9f7ff', fontSize: 26 }}
              size={64}
            >
              <Flex align="center" justify="center">
                {item.status === MonitoringItemStatus.OFFLINE ? <PoweroffOutlined style={{ color: 'red', transform: 'rotate(180deg)' }} /> : <PoweroffOutlined style={{ color: 'green' }} />}
              </Flex>
            </Avatar>
            <div style={{ marginLeft: '1rem', height: '100%' }}>
              <p style={{ color: '#949494', marginBottom: '0.25rem' }}>
                {item.title}
              </p>
              <span
                style={{ color: item.color ? item.color : item.status === MonitoringItemStatus.OFFLINE ? 'red' : 'green' }}
                className="overview-page-stats__count"
              >
                {item.value} {item.description && <span style={{ fontSize: '0.8rem', color: '#949494' }}>{item.description}</span>}
              </span>
            </div>
            {isClickable && <div
              style={{ position: 'absolute', right: 0, marginRight: '1rem' }}
            >
              <Tooltip title="Ouvrir">
                <ExportOutlined />
              </Tooltip>
            </div>}
          </>
        )}
      </div>
    </Card>
  );
};